/*
Mike Rodriguez
LWTech
JavaScript
Final Project
*/
import React from 'react';
// importing the components from game.js
import Game from './components/Game';

// inporting game function to run as game in App function
const App = () => <Game />;

// allows the function to be exported
export default App;
